<template>
  <el-drawer
    v-model="val"
    custom-class="pro-drawer"
    size="70%"
    :close-on-click-modal="false"
    destroy-on-close
  >
    <template #title>
      <h4>{{ title }}</h4>
    </template>

    <el-form
      :model="releaseNoticeForm"
      :rules="rules"
      ref="releaseNoticeForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="消息标题:" prop="titleTest">
        <el-input v-model="releaseNoticeForm.titleTest"></el-input>
      </el-form-item>
      <el-form-item label="消息内容:" prop="test">
        <!-- 富文本编辑器 -->
        <WangEditor ref="getWangEditor"></WangEditor>
      </el-form-item>
    </el-form>

    <template #footer>
      <div style="flex: auto">
        <el-button @click="val = false">取消</el-button>
        <el-button type="primary" @click="submitForm('releaseNoticeForm')"
          >保存</el-button
        >
      </div>
    </template>
  </el-drawer>
</template>
<script>
import WangEditor from "./WangEditor.vue";
import { ElMessage } from "element-plus";
import { defineComponent, ref } from "vue";
import { releaseNoticeList, queryNotice } from "@/api/notice/index";
export default defineComponent({
  components: { WangEditor },
  emits: ["update:modelValue", "scarch"],
  data() {
    return {
      releaseNoticeForm: {
        titleTest: "",
        test: "",
      },
      rules: {
        titleTest: [{ required: true, message: "请输入公告名称" }],
        test: [{ required: true, message: "请输入公告内容" }],
      },
      editTest: "",
      projectId:"",//编辑时候用到id
      isShow:"",
    };
  },
  props: {
    modelValue: Boolean,
    title: String,
  },
  computed: {
    val: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.projectId="";
        this.isShow="";
        this.releaseNoticeForm.titleTest = "";
        this.$emit("update:modelValue", value);
      },
    },
  },
  mounted() {},
  methods: {
    //通过id查询出数据进行编辑
    editNoticeTest(val) {
      let that=this;
      queryNotice(val).then(({ data }) => {
        if (data && data.status == true) {
          that.projectId=data.data.data.id
          that.releaseNoticeForm.titleTest = data.data.data.title;
          that.$nextTick(() => {
            that.$refs.getWangEditor.editNoticeWangEditor(data.data.data.center);
          });
          that.isShow=data.data.data.isShow
        } else {
          ElMessage({
            message: data.msg,
            type: "warning",
          });
        }
      }).catch((_) => {});
    },
    //保存按钮
    submitForm(formName) {
      let that = this;
      this.releaseNoticeForm.test = this.$refs.getWangEditor.wangEditorTest;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.release();
        } else {
          return false;
        }
      });
    },
    //发布
    release() {
      const params = {
        title: this.releaseNoticeForm.titleTest,
        center: this.$refs.getWangEditor.wangEditorTest,
        id:this.projectId,
        isShow:this.isShow,
      };
      releaseNoticeList(params)
        .then(({ data }) => {
          if (data && data.status == true) {
            ElMessage({
              message: "保存成功",
              type: "success",
            });
            this.val = false;
            this.$emit("scarch");
          } else {
            ElMessage({
              message: data.msg,
              type: "warning",
            });
            this.val = false;
            this.$emit("scarch");
          }
        })
        .catch((_) => {});
    },
  },
});
</script>

<style lang="scss" >
.pro-drawer {
  .el-drawer__header {
    padding: 0px 10px 0px 10px;
    background: #f7f7f7;
    margin-bottom: 0px;
  }
}
</style>